import { render } from "./CapabilitiesSelector.vue?vue&type=template&id=ec9f0ce2"
import script from "./CapabilitiesSelector.vue?vue&type=script&lang=js"
export * from "./CapabilitiesSelector.vue?vue&type=script&lang=js"

import "./CapabilitiesSelector.vue?vue&type=style&index=0&id=ec9f0ce2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__